var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.htmlTag,{tag:"component",style:(_vm.style)},[_vm._t("default"),_c('grid-viewport-listener',{model:{value:(_vm.size),callback:function ($$v) {_vm.size=$$v},expression:"size"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }